<!--
  <!>WARNING<!>
  This is really dumb but IE 11 cares about the order of attributes.
  Make sure that `{value}` comes immediatley after `type="checkbox"`.
  Otherwise `{value}` will be `on` and not the message text. But only
  on the first render making it very tricky to track down.
-->
<input
  {id}
  class="ne-radio"
  type="checkbox"
  {value}
  {checked}
  on:click="{event => choose(event)}" />
<label for={id} class="ne-message-box">
  <span class="ne-message">{text}</span>
</label>

<style>
  .ne-radio {
    border-radius: 2em;
    grid-column: 1;
    grid-row: 1;
  }

  .ne-radio + .ne-message-box::before {
    border-color: #666e7e;
    background-color: #fff;
  }

  .ne-radio:checked + .ne-message-box::before {
    border-color: #CE2333;
    background-color: #CE2333;
  }

  .ne-radio + .ne-message-box::after {
    content: none;
  }

  .ne-radio:checked + .ne-message-box::after {
    content: '';
  }

  .ne-radio {
    opacity: 0;
  }

  .ne-message-box {
    padding: 1em;
    cursor: pointer;
    display: block;
    position: relative;
    padding-left: 3em;
    grid-column: 1;
    grid-row: 1;
  }

  .ne-message-box::before,
  .ne-message-box::after {
    position: absolute;
    content: '';
    display: inline-block;
  }

  .ne-message-box::before {
    border-width: .0625em;
    border-style: solid;
    height: 1em;
    width: 1em;
    border-radius: 2em;
    line-height: 1.5em;
    left: 1em;
  }

  .ne-message-box::after {
    height: .3em;
    width: .5em;
    border-left: .1em solid #fff;
    border-bottom: .1em solid #fff;

    transform: rotate(-50deg);

    left: 1.25em;
    top: 1.3em;
  }

  .ne-message {
    justify-self: center;
    align-self: center;
    width: 100%;
  }
</style>

 <script>
   export let id;
   export let value;
   export let checked;
   export let text;
   export let choose;
 </script>
